import { render, staticRenderFns } from "./ysCamera.vue?vue&type=template&id=f89153ba&scoped=true"
import script from "./ysCamera.vue?vue&type=script&lang=js"
export * from "./ysCamera.vue?vue&type=script&lang=js"
import style0 from "./ysCamera.vue?vue&type=style&index=0&id=f89153ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89153ba",
  null
  
)

export default component.exports